export default __webpack_public_path__ + "static/media/settings.4ab80b1c.svg";